export default function HelperClass(){
    return {
        CUSTOMER_SITE:'easi'
    }
}